import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
// La fiche sous préfixe statique « file/ » : ses onglets prennent le reste de l'URL (leçon S4).
export const MaintenanceAircraftRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--maintenance--fleet', 'role--maintenance--client']}>
    <Route path='file/:aircraftId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
